import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle, FaCog, FaCheck, FaBullhorn } from "react-icons/fa";

const RaiseHeader = ({ isProfileComplete }) => {
  const navigate = useNavigate();

  return (
    <header className="bg-white shadow-sm h-16 flex items-center justify-end px-6">
      <div className="flex items-center space-x-4">
        {/* Raise Voice Button */}
        {/* <button
          onClick={() => navigate('/raiseyourvoice/raise-voice')}
          className="p-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-all duration-300 flex items-center gap-2"
          title="Raise Your Voice"
        >
          <FaBullhorn className="w-5 h-5" />
        </button> */}

        {/* Profile Button */}
        <div className="relative">
          <button
            onClick={() => navigate('/raise/profile')}
            className="p-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-all duration-300"
            title="Profile"
          >
            <FaUserCircle className="w-5 h-5" />
            {/* Verification Badge */}
            {isProfileComplete && (
              <div className="absolute -top-1 -right-1 bg-green-500 rounded-full p-1 border-2 border-white">
                <FaCheck className="w-2 h-2 text-white" />
              </div>
            )}
          </button>
        </div>

        {/* Settings Button */}
        {/* <button
          onClick={() => navigate('/raiseyourvoice/settings')}
          className="p-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-full transition-all duration-300"
          title="Settings"
        >
          <FaCog className="w-5 h-5" />
        </button> */}
      </div>
    </header>
  );
};

export default RaiseHeader;
